import { ApplicationsErrorCode, createApplicationsError, } from '../Applications/ApplicationsError';
import { classMetadataKey } from './common';
import { getMetadata } from 'reflect-metadata/no-conflict';
const isMethodAllowed = (path, config) => {
    const reversedPath = [...path].reverse();
    for (const step of reversedPath) {
        if (!step.metadata?.length) {
            continue;
        }
        return step.metadata.some((checker) => checker(config));
    }
    return true;
};
const getCurrentPath = (path = [], classMetadata) => {
    if (!classMetadata?.length) {
        return path;
    }
    return [...path, { metadata: classMetadata, key: classMetadataKey }];
};
export const buildLimitedPrivateApi = (api, config, path = []) => new Proxy(api, {
    get: (target, key) => {
        const metadata = getMetadata('api-config', target, key);
        const reflectValue = Reflect.get(target, key);
        const value = typeof reflectValue === 'function'
            ? reflectValue.bind(api)
            : reflectValue;
        if (!isMethodAllowed([...path, { metadata, key }], config)) {
            return undefined;
        }
        if (typeof value === 'object' || typeof value === 'function') {
            return buildLimitedPrivateApi(value, config, [
                ...getCurrentPath(path, getMetadata('api-config', value.constructor, classMetadataKey)),
                { metadata, key },
            ]);
        }
        return value;
    },
    apply: (target, thisArg, argArray) => {
        const isAllowed = isMethodAllowed(path, config);
        if (!isAllowed) {
            const methodPath = path
                .map((item) => item.key)
                .filter((key) => key !== classMetadataKey)
                .join('.');
            throw createApplicationsError(ApplicationsErrorCode.ForbiddenPrivateApiCall)
                .withMessage("This method isn't allowed to be called in this type of application & environment")
                .withMethod(methodPath)
                .withEnv(config.env)
                .withAppType(config.type);
        }
        return Reflect.apply(target, thisArg, argArray);
    },
    set: (target, key, value) => {
        return Reflect.set(target, key, value);
    },
});
//# sourceMappingURL=buildLimitedPrivateApi.js.map